import { JsonBodyRemarkPlugin } from './markdown-plugins-utils.js';
import { SourcesMarkdownItem } from './sources-markdown-item.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/** Directive name used in markdown container blocks: `:::sources` */
export const SOURCES_DIRECTIVE = 'sources';

/**
 * Remark plugin definition for the `sources` container directive.
 *
 * Usage in markdown:
 * ```
 * :::sources
 * [{"fileId":"...","pageNumbers":[3,7]}]
 * :::
 * ```
 *
 * The directive body is parsed as JSON and passed to {@link SourcesMarkdownItem}
 * via the `jsonData` prop.
 */
export const sourcesDirectiveDefinition: RemarkMarkdownDirectiveDefinition = {
	allowedAttributes: ['jsonData'],
	directive: JsonBodyRemarkPlugin(SOURCES_DIRECTIVE),
	item: SourcesMarkdownItem,
};
